import * as yup from 'yup'
import { TFunction } from 'i18next'

export const validationSchema = (t: TFunction) => {
  return yup.object().shape({
    date: yup.date().nullable().required(t('sponsor.validation.date_required'))
  })
}
